(function () {
    'use strict';

    a3_cabin_reports.directive('course', course);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name course
    * @restrict E
    * @description
    *   Implementation of training course
    * @example
    *   Usage:
    *   <course></course>
    * @ngInject
    */
    function course(GroundDutyFactory, CourseFactory, TrainingSessionFactory, FlightSessionFactory, $timeout, $uibModal, $location, $routeParams, $window) {
        function link(scope) {
            var courseId = scope.dutyCourse.Id;

            var isGround = false;

            if(scope.groundDuty){
                isGround = true;
                var date = scope.groundDuty.DutyDateS;
                var dutyId = scope.groundDuty.Id;
            }
            else{
                var date = scope.crewRouteDuty.date;
                var dutyNo = scope.crewRouteDuty.DutyNo;
                var dutyDay = scope.crewRouteDuty.DutyDay;

                var trainingFlightIds = scope.crewRouteDuty.Courses.find(x => x.CourseId == courseId && new moment(x.Date).isSame(date)).TrainingFlightIds;
                
                if(scope.course.Media) scope.course.Media.radioModel = "Flight";
            }

            scope.isGround = isGround;
            
            scope.updateSession = updateSession;
            scope.availableCourseInfo = false;
            scope.oneTraineeAtATime = true;
            scope.allAbsent = false;
            scope.SubmitSession = SubmitSession;
            scope.close = close;
            scope.updateTraineeSignatures = updateTraineeSignatures;
            scope.checkReleaseAvailability = checkReleaseAvailability;
            scope.setReleaseStatus = setReleaseStatus;
            scope.reloadReleasePanel = reloadReleasePanel;
            scope.showReleasePanel = showReleasePanel;

            scope.filterSelectedSyllabus = filterSelectedSyllabus;
            scope.filterPresentTrainees = filterPresentTrainees;

            scope.selectedPhaseIndex = selectedPhaseIndex();

            scope.releaseTrainee = releaseTrainee;
            scope.showReleaseBtn = showReleaseBtn;
            scope.showGroupReleaseBtn = showGroupReleaseBtn;
            scope.releaseGroup = releaseGroup;
            scope.validateTraineeForm = validateTraineeForm;
            scope.openTraineeSignature = openTraineeSignature;
            scope.resetSignature = resetSignature;


            scope.getTraineeClass = getTraineeClass;
            scope.leftScroll = leftScroll;
            scope.rightScroll = rightScroll;
            scope.togglePanel = togglePanel;


            scope.isReleaseSelected = false;
            scope.toggleBtn = toggleBtn;
                     
            scope.setAdditionalTrainingDetails = setAdditionalTrainingDetails;
            scope.hasLowDayGrading = hasLowDayGrading;
            scope.hasLowSyllabusGrading = hasLowSyllabusGrading;

            if(scope.selectedPhase.ModuleType == "Training" && scope.selectedPhase.EnableAdditionalTraining){
                scope.AvailableAdditionalTraining = true;
            }

            function setAdditionalTrainingDetails() {
                if(scope.isReleaseSelected){                 
                    if(scope.selectedTrainee.Session.AdditionalTrainingRemarks != undefined){
                        scope.selectedTrainee.Session.AdditionalTrainingRemarks = '';
                    }
                    scope.selectedTrainee.Session.CompleteAdditionalTraining = true;
                    scope.selectedTrainee.Session.NeedsAdditionalTraining = false;
                }
             
            }

            function toggleBtn() {
                scope.isReleaseSelected = !scope.isReleaseSelected;
            }

            function selectedPhaseIndex(){             
                var index = 0;
                scope.course.CrewCoursePhases.some(function(phase, i) {
                    if (phase.PhaseId == scope.selectedPhase.PhaseId) {
                    index = i;
                    return true;
                 }
                });
                return index;
            }

            function filterSelectedSyllabus(){
                return function( syllabus ) {
                    var showTrainee = true;
                    if(scope.traineeSyllabi && scope.traineeSyllabi.length > 1){
                        showTrainee = syllabus.TraineeIds[0] == scope.selectedTrainee.CrewId;
                    }
                    return showTrainee;
                };
            }

            function filterPresentTrainees(){
                return function( trainee ) {
                    return !trainee.Session.Absent;
                };
            }

            scope.reloadFooter = true;
            scope.reloadRelease = true;
            
            setTraineeSessions();
            updateSession();
            setReleaseStatus();

            function ResetTraineeSignatures(){
                scope.trainees.forEach(function(trainee){
                    trainee.Session.Authorized = false;
                });
            }

            function setReleaseStatus(){
                scope.trainees.forEach(function(trainee){trainee.ShowReleaseWarning = false;});
                scope.course.AvailableRelease = checkReleaseAvailability();

                //Handle trainee signatures
                scope.requiresTraineeSignature = RequiresTraineeSignature();
                if(!scope.requiresTraineeSignature) ResetTraineeSignatures();
                scope.allSignaturesComplete = !scope.trainees.filter(x => !x.Session.Absent).some(x => !x.Session.Authorized);
                scope.someSignaturesComplete = scope.trainees.filter(x => !x.Session.Absent).some(x => x.Session.Authorized);

                //For flights : check minDays - minSectors
                if(!isGround && scope.course.AvailableRelease && (scope.selectedPhase.MinDays > 0 || scope.selectedPhase.MinSectors > 0)){
                    scope.trainees.filter(x => x.AvailableRelease).forEach(function(trainee){
                        var phaseInfo = trainee.Phases.find(x => x.PhaseId == scope.selectedPhase.PhaseId);
                        var completedDays = 0;
                        var completedSectors = 0;
                        if(phaseInfo.Sessions){ //previous sessions
                            completedDays = phaseInfo.Sessions.length;

                            phaseInfo.Sessions.forEach(function(pastSession){
                                if(pastSession.Sectors){
                                    completedSectors = completedSectors + pastSession.Sectors.length;
                                }
                            })
                        }
                        
                        trainee.CompletedDays = completedDays + 1 ; //add current day
                        trainee.CompletedSectors = completedSectors + trainingFlightIds.length; //add current sectors
                        if(trainee.CompletedDays < scope.selectedPhase.MinDays || trainee.CompletedSectors < scope.selectedPhase.MinSectors){
                            trainee.ShowReleaseWarning = true;
                        }
                    });
                }

                //For ground: check aircraft visits
                if(isGround && (scope.course.AvailableRelease || scope.selectedPhase.ModuleType=="Check") && scope.selectedPhase.AircraftTypes.length){
                    var trainees = scope.trainees;
                    if(scope.selectedPhase.ModuleType!="Check") trainees.filter(x => x.AvailableRelease);
                    trainees.forEach(function(trainee){
                        var phaseInfo = trainee.Phases.find(x => x.PhaseId == scope.selectedPhase.PhaseId);
                        var visitedAircrafts = [];
                        
                        if(phaseInfo.Sessions){ //previous sessions
                            phaseInfo.Sessions.forEach(function(session){
                                visitedAircrafts = visitedAircrafts.concat(session.AircraftTypesVisited)
                            });
                        }
                        
                        if(scope.course.Media){
                            trainee.visitedAircrafts = visitedAircrafts.concat(scope.course.Media.inputAircrafts); //add current arvis
                        }
                        trainee.pendingAircrafts = [];
                        trainee.pairPendingAircrafts = [];                   

                        var pendingAircrafts = [];
                        scope.selectedPhase.AircraftTypes.forEach(function(type){
                            var array = type.split(',');

                            //if arvi requirement is not met
                            if (trainee.visitedAircrafts && !array.some(x => trainee.visitedAircrafts.includes(x))) {
                                var pendingArviList = [];
                                if (array.length > 1) 
                                {
                                    array.forEach(function(arvi){
                                        pendingArviList.push(arvi);
                                    });
                                }
                                else
                                {
                                    pendingArviList.push(array[0]);
                                }
                                pendingAircrafts.push(pendingArviList);
                            }
                        });

                        trainee.pendingAircrafts = pendingAircrafts;
                        trainee.ShowReleaseWarning = trainee.pendingAircrafts.length>0;
                    });
                }
                scope.showReleaseWarning = scope.trainees.some(x => x.ShowReleaseWarning);
            }

            function reloadReleasePanel(){
                setReleaseStatus();
                scope.reloadRelease = false;
                $timeout(function () {
                    scope.reloadRelease = true;
                }, 100);

            }

            function updateSession() {
                scope.trainees.forEach(function(trainee) {trainee.Session.selected = false;});

                if(scope.selectedTraineeBadge && scope.trainees.find(x => x.CrewId == scope.selectedTraineeBadge.CrewId)){
                    scope.trainees.find(x => x.CrewId == scope.selectedTraineeBadge.CrewId).Session.selected = true;
                    scope.selectedTrainee =  scope.trainees.find(x => x.Session.selected);
                }

                if(isGround){
                    TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) { console.log(e) })
                }
                else{
                    FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) { console.log(e) })
                }
            }

            function setTraineeSessions() {
                var phase = scope.selectedPhase;
                // Set Day Grading
                var dayCompetences = phase.DayGrading.Competences;
                dayCompetences.forEach(function (competence) { 
                    competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences); 
                    competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences); 

                    //Filter out from optional the ones common with mandatory
                    competence.OptionalSub = competence.OptionalSub.filter(c => !competence.MandatorySub.includes(c));
                });


                var dayGradingSessions = scope.trainees.map(x => x.Session.DayGrading);
                dayGradingSessions.forEach(function (traineeSession) {
                    traineeSession.Competences = setTraineeCompetences(dayCompetences, traineeSession);
                });

                // Set Release Grading
                var releaseCompetences = phase.ReleaseGrading.Competences;
                releaseCompetences.forEach(function (competence) { 
                    competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences); 
                    competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences);

                    //Filter out from optional the ones common with mandatory
                    competence.OptionalSub = competence.OptionalSub.filter(c => !competence.MandatorySub.includes(c));
                });
                var releaseGradingSessions = scope.trainees.map(x => x.Session.ReleaseGrading);
                releaseGradingSessions.forEach(function (traineeSession) {
                    traineeSession.Competences = setTraineeCompetences(releaseCompetences, traineeSession);
                });

                // Set Syllabus
                if (scope.selectedPhase.Syllabus) setSyllabus();

                //Check if all are absent
                if(scope.trainees && scope.trainees.length && !scope.trainees.some(x => !x.Session.Absent)){
                    scope.allAbsent = true;
                }        
            }

            function setSyllabus() {
                var traineeSyllabi = [];

                if (!scope.selectedPhase.Syllabus.IsGradable && !scope.selectedPhase.InFlight) { //Non Gradable syllabus & Ground: All trainees share the same syllabus
                    var traineeSyllabus = {
                        TraineeIds: scope.trainees.filter(x => !x.Session.Absent).map(x => x.CrewId),
                        Items: []
                    };
                    traineeSyllabi.push(traineeSyllabus);
                }
                else { //Gradable syllabus || flight: each trainee will have its own
                    scope.trainees.filter(x => !x.Session.Absent).forEach(function (trainee) {
                        var traineeSyllabus = {
                            TraineeIds: [trainee.CrewId],
                            Items: []
                        };
                        traineeSyllabi.push(traineeSyllabus);
                    });
                }

                //Set syllabus item sub competences 
                scope.selectedPhase.Syllabus.SyllabusItems.forEach(function (item) {
                    item.Competences.forEach(function (competence) { 
                        competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences); 
                        competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences);

                        //Filter out from optional the ones common with mandatory
                        competence.OptionalSub = competence.OptionalSub.filter(c => !competence.MandatorySub.includes(c));
                    });
                });

                scope.trainees.filter(x => !x.Session.Absent).forEach(function (trainee) {                 
                    var traineeSessionItems = [];
                    scope.selectedPhase.Syllabus.SyllabusItems.forEach(function (item) {
                        var syllabusItem = JSON.parse(JSON.stringify(item));

                        //Get any history tries
                        var historyTries = [];
                        if (syllabusItem.History && syllabusItem.History.length) {
                            var itemsHistory = syllabusItem.History.filter(x => x.CrewId == trainee.CrewId);
                            if (itemsHistory.length) {
                                var allHistoryTries = [];
                                itemsHistory.forEach(function(item){
                                    allHistoryTries = allHistoryTries.concat(item.Tries);
                                });
                                    allHistoryTries.forEach(function (historyTry) {
                                        var performedTry = { 
                                            ActionNo : historyTry.ActionNo,
                                            isReadOnly : true,
                                            Comments : historyTry.Comments,
                                            InstructorName : historyTry.InstructorName,
                                            SubmissionDate : historyTry.SubmissionDate,
                                            Grade : historyTry.TryGrading.Grade,
                                            AcTypes : historyTry.AcTypes,
                                            Sectors : historyTry.Sectors
                                        };                                       
                                        historyTries.push(performedTry);
                                    })                            
                            }
                        }

                        var relatedSessionItem = trainee.Session.Items.find(x => x.Id == syllabusItem.Id);

                        //Pending tries
                        var pendingTriesLeft = syllabusItem.MandatoryCount - historyTries.length;
                   
                        if(syllabusItem.MandatoryCount == 0 && historyTries.length == 0){    //for non-mandatory items: add 1 attempt if not already performed
                            pendingTriesLeft = 1;
                        }

                        var pendingTries = [];
                        for (var i = 0; i < pendingTriesLeft; i++) {
                            pendingTries.push({
                                Comments: null,
                                ActionNo: (historyTries.length) + i + 1,
                                isFirstTry: i == 0,
                                TryGrading: { 
                                    Grade: syllabusItem.DefaultGrade? syllabusItem.DefaultGrade : null, 
                                    Competences: [], 
                                    GradeType: syllabusItem.GradeType 
                                }
                            });
                        }

                        //Add pending tries to history tries
                        var tries = historyTries.concat(pendingTries);

                        //Create syllabus item depending on existing values
                        if (!relatedSessionItem) {
                            tries.filter(x => !x.isReadOnly).forEach(function (attempt) {
                                attempt.TryGrading.Competences = setTraineeCompetences(syllabusItem.Competences, attempt.TryGrading);
                            });

                            var newItem = {
                                RepeatRequired: false,
                                Selected: false,
                                Tries: tries,
                                PhaseId: scope.selectedPhase.PhaseId,
                                Id: syllabusItem.Id
                            };
                            traineeSessionItems.push(newItem);
                            mergeSyllabusItemWithSession(syllabusItem, newItem);
                        }
                        else {
                            var sessionTries = [];
                            tries.forEach(function (tryItem) {
                                var relatedSessionTry = relatedSessionItem.Tries.find(x => x.ActionNo == tryItem.ActionNo);
                                if (relatedSessionTry && !tryItem.isReadOnly) {
                                    sessionTries.push(deepCopy(relatedSessionTry));
                                }
                                else {
                                    sessionTries.push(deepCopy(tryItem));
                                }
                            });

                            //Add any Extra tries
                            if(syllabusItem.MandatoryCount>0){
                                var extraTries = relatedSessionItem.Tries.filter(x => x.ActionNo > syllabusItem.MandatoryCount && !x.isReadOnly);
                                sessionTries = sessionTries.concat(extraTries);
                            }

                            sessionTries.filter(x => !x.isReadOnly).forEach(function (attempt) {
                                attempt.TryGrading.Competences = setTraineeCompetences(syllabusItem.Competences, attempt.TryGrading);
                            });

                            var existingItem = {
                                RepeatRequired: relatedSessionItem.RepeatRequired,
                                Selected: relatedSessionItem.Selected,
                                Tries: sessionTries,
                                PhaseId: scope.selectedPhase.PhaseId,
                                Id: syllabusItem.Id
                            };
                          
                            traineeSessionItems.push(existingItem);
                            mergeSyllabusItemWithSession(syllabusItem, existingItem);
                        }

                        var traineeSyllabus = traineeSyllabi.find(x => x.TraineeIds.includes(trainee.CrewId));
                        if (!traineeSyllabus.Items.some(x => x.Id == syllabusItem.Id)) { 
                            traineeSyllabus.Items.push(syllabusItem);  
                        }
                    });

                    trainee.Session.Items = traineeSessionItems;
                });



                traineeSyllabi.forEach(function(syllabus){
                    SyllabusGrouping(syllabus);
                })
                scope.traineeSyllabi = traineeSyllabi;
            }

            function mergeSyllabusItemWithSession(syllabusItem, sessionItem) {
                syllabusItem.RepeatRequired = sessionItem.RepeatRequired;
                syllabusItem.Selected = sessionItem.Selected;
                syllabusItem.Tries = sessionItem.Tries;
            }

            function leftScroll() {
                document.querySelector('.horizontal-scroll').scrollLeft -= 500;
            }
            
            function rightScroll() {
                document.querySelector('.horizontal-scroll').scrollLeft += 500;
            }

            function deepCopy(originalObject) {
                return JSON.parse(JSON.stringify(originalObject));
            }

            function SyllabusGrouping(syllabus) {
                //Syllabus Items Group By 'GroupId'
                var syllabusGroups = [];
                syllabus.Items.forEach(function (item) {
                    if (!syllabusGroups.some(x => x.Id == item.SelectedGroup.Id)) {
                        if (!item.SelectedGroup) {
                            item.SelectedGroup = {
                                Id: 0,
                                Title: 'General'
                            };
                        }

                        var syllabusGroup = {
                            Id: item.SelectedGroup.Id,
                            Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
                            Items: []
                        };

                        syllabusGroup.Items.push(item);
                        syllabusGroups.push(syllabusGroup);
                    }
                    else {
                        syllabusGroups.filter(x => x.Id == item.SelectedGroup.Id)[0].Items.push(item);
                    }
                });

                syllabus.ItemsGrouped = syllabusGroups;
            }

            function setTraineeCompetences(competences, sessionItem) {
                var traineeCompetences = [];
                competences.forEach(function (competence) {
                    var traineeCompetence = JSON.parse(JSON.stringify(competence));
                    var existingCompetence = sessionItem.Competences.find(x => x.Id == traineeCompetence.Id);
                    //Get saved values
                    traineeCompetence.Grading = existingCompetence ? existingCompetence.Grading : null;
                    traineeCompetence.Comments = existingCompetence ? existingCompetence.Comments : null;
                    if (existingCompetence) {
                        traineeCompetence.SubCompetences.filter(x => existingCompetence.SubCompetences.some(y => y.Id == x.Id)).forEach(function (commonSub) {
                            commonSub.Selected = existingCompetence.SubCompetences.find(s => s.Id == commonSub.Id).Selected;
                        });
                        traineeCompetence.hasMandatory = traineeCompetence.MandatorySub.includes(Number(traineeCompetence.Grading));
                        traineeCompetence.hasOptional = traineeCompetence.OptionalSub.includes(Number(traineeCompetence.Grading));
                    }
                    traineeCompetences.push(traineeCompetence);
                });
                return traineeCompetences;
            }

            
            function setSubCompetenceValues(current) {
                var updated = [];
                var first = parseInt(current[0], 10);
                var last = current[current.length - 1];

                if (first) {
                    for (var i = first; i <= last; i++) {
                        updated.push(i);
                    }
                }
                return updated;
            }



            /*****************************************************************  Submit ********************************************************************************/
            function SubmitSession() {
                setReleaseStatus();
                if (!isValidForm()) {
                    scope.modalInstance = $uibModal.open({
                        templateUrl: 'views/Training/dlgSubmitValidation.html',
                        scope: scope,
                        backdrop: 'static',
                        keyboard: false,
                        size: 'lg'
                    });
                }
                else {

                    if(isGround){
                        //Last save before submission
                        TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, function () {
                            // Get all trainees found for this session (filter by course and date)
                            TrainingSessionFactory.getSessionTrainees(courseId, date, dutyId, function (Trainees) {
                                var absentTrainees = Trainees.filter(x => x.Session.Absent);

                                if (absentTrainees.length > 0){
                                    scope.modalInstance = $uibModal.open({
                                        templateUrl: 'views/Training/dlgAbsentTrainees.html',
                                        controller: 'AbsentTraineesModalCtrl', 
                                        scope: scope,
                                        backdrop: 'static',
                                        keyboard: false,
                                        size: 'md',
                                        resolve: {
                                            absentTrainees: function(){
                                                return absentTrainees;
                                            }
                                        }
                                    });

                                    scope.modalInstance.result.then(function (response) {
                                        if (response === 'confirmed') {
                                            manageSubmission(Trainees);
                                        }
                                    });
                                } else {
                                     manageSubmission(Trainees);
                                }
                            });
                        });
                    }
                    else{
                        //Last save before submission
                        FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, function () {
                            // Get all trainees found for this session (filter by course and date)
                            FlightSessionFactory.getSessionTrainees(courseId, date, dutyNo, dutyDay, function (Trainees) {
                                manageSubmission(Trainees);
                            });
                        });
                    }
                }
            }

            function manageSubmission(Trainees){
                PrepareSessionForSubmission(Trainees);
                setReleaseStatus();
                
                var requiresInstructorSignature = RequiresInstructorSignature();

                var confirmationMsg = scope.selectedPhase.ReleaseGrading.ConfirmationMessage
                
                // submit now
                var releaseGrading =    (scope.selectedPhase.ReleaseGrading.Comments || 
                    scope.selectedPhase.ReleaseGrading.GradeType == 'Numeric' || 
                    scope.selectedPhase.ReleaseGrading.GradeType == 'Outcome' ||
                    scope.selectedPhase.ReleaseGrading.Competences.length) &&
                    scope.selectedPhase.ReleaseGrading.GradeType != 'CertificateExam';

                //var isAdditionalTraining = false;   
                var needsAdditionalTraining = false;
                if(scope.selectedTrainee != null){
                    needsAdditionalTraining = scope.selectedTrainee.NeedsAdditionalTraining
                }

                scope.modalInstance = $uibModal.open({
                    templateUrl: 'views/Training/dlgSign.html',
                    controller: 'SignatureModalCtrl',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        courseId: function () { return courseId; },
                        date: function () { return date; },
                        dutyId: function () { return dutyId; },
                        dutyNo: function () { return dutyNo; },
                        dutyDay: function () { return dutyDay; },
                        confirmationMsg: function () { return confirmationMsg; },
                        requiresInstructorSignature: function () { return requiresInstructorSignature },
                        trainees: function () { return scope.trainees },
                        submitSession: function () { return SaveSession; },
                        releaseGrading: function () { return releaseGrading;},
                        isReleased: function () { return scope.course.ReleasedPhase;},
                        needsAdditionalTraining: function () { return needsAdditionalTraining;}                        
                    }
                });

                scope.modalInstance.result.then(function (result) {
                    if(result.success){
                        $location.path("/");
                    }
                });
            }

            function RequiresTraineeSignature(){
                // End of session signature
                var endOfSessionSignature = scope.selectedPhase.DayGrading.TraineeSignature;

                // End of module signature
                var endOfModuleSignature = scope.course.ReleasedPhase && scope.selectedPhase.ReleaseGrading.TraineeSignature;

                return endOfSessionSignature || endOfModuleSignature;
            }

            function RequiresInstructorSignature(){
                /*  Instructor signature needed if
                    1. Syllabus attached needs signature
                    2. Completed syllabus items need signature
                    3. End of session needs signature
                    4. Module is released and end of module needs signature
                */

                // 1. Check if syllabus exists and needs signature
                var syllabusSignature = scope.selectedPhase.Syllabus && scope.selectedPhase.Syllabus.SignatureRequired;

                // 2. Filter selected syllabus items & check if they need signature
                var selectedItems = [];
                scope.trainees.forEach(function(trainee){
                    var traineeSelectedItems = trainee.Session.Items.filter(x => x.Selected).map(x => x.Id);
                    selectedItems = selectedItems.concat(traineeSelectedItems);
                })
                selectedItems = [...new Set(selectedItems)];

                var syllabusItemSignature = scope.selectedPhase.Syllabus && scope.selectedPhase.Syllabus.SyllabusItems.filter(x => selectedItems.includes(x.Id)).some(x => x.SignatureRequired);

                // 3. End of session signature
                var endOfSessionSignature = scope.selectedPhase.DayGrading.InstructorSignature;

                // 4. End of module signature
                var endOfModuleSignature = scope.course.AvailableRelease && scope.course.ReleasedPhase && scope.selectedPhase.ReleaseGrading.InstructorSignature;

                return syllabusSignature || syllabusItemSignature || endOfSessionSignature || endOfModuleSignature;
            }
            

            /**
             * Check if Release requirements are met
             * @param {object} group 
             */
            function checkReleaseAvailability() {
                //Available Release if No pending mandatory items
                //Calculate item status for each trainee
                scope.trainees.filter(x => !x.Session.Absent).forEach(function(sessionTrainee){

                    if(scope.selectedPhase.Syllabus){
                        var syllabusItems = scope.selectedPhase.Syllabus.SyllabusItems;
                        sessionTrainee.Session.Items.forEach(function(sessionItem){
                            var performedTries = sessionItem.Tries.filter(x => x.isReadOnly || x.Selected).length; // history & current session
                            var mandatoryCount = syllabusItems.find(x => x.Id == sessionItem.Id).MandatoryCount;

                            sessionItem.Status = (mandatoryCount>0 && performedTries < mandatoryCount) ? "Pending" : "Completed";
                        });
    
                        sessionTrainee.AvailableRelease = !sessionTrainee.Session.Items.some(x => x.Status == "Pending");
                    }
                    else{
                        sessionTrainee.AvailableRelease = true;
                    }
                    
                });
                
                if(scope.selectedPhase.ModuleType == "Training"){
                    scope.trainees.filter(x => !x.Session.Absent && !x.AvailableRelease).forEach(function(trainee){
                        trainee.Session.Released = false;
                    });

                    if(scope.trainees.filter(x => !x.Session.Absent).some(x => !x.AvailableRelease)){
                        scope.trainees.filter(x => !x.Session.Absent).forEach(function(trainee){
                            trainee.Session.Released = false;
                        })
                    }
                }

                scope.course.ReleasedPhase = scope.trainees.filter(x => !x.Absent).some(x => x.Session.Released);
                return !scope.trainees.filter(x => !x.Session.Absent).some(x => !x.AvailableRelease);  
                
            }

            function SaveSession(password, withRelease) {
                scope.submittedSession.SignaturePassword = password;

                if(scope.submittedSession.TraineeSessions.filter(x => x.AdditionalTrainingStatus == 'UnderAdditionalTraining').length > 0){
                     scope.submittedSession.TraineeSessions.filter(x => !x.Absent && scope.selectedTrainee.AdditionalTrainingStatus == 'UnderAdditionalTraining').forEach(function(trainee){
                    if(!trainee.NeedsAdditionalTraining)
                    {
                        trainee.NeedsAdditionalTraining = false;
                        trainee.UnderAdditionalTraining = true;
                        trainee.CompleteAdditionalTraining = true;
                    }
                });
                }
                if(scope.submittedSession.TraineeSessions.find(x => x.CompleteAdditionalTraining == true)) {
                    scope.submittedSession.TraineeSessions.filter(x => !x.Absent && scope.selectedTrainee.AdditionalTrainingStatus == 'UnderAdditionalTraining').forEach(function(trainee){
                        if(!trainee.NeedsAdditionalTraining)
                        {
                            trainee.NeedsAdditionalTraining = false;
                            trainee.UnderAdditionalTraining = true;
                            trainee.CompleteAdditionalTraining = true;
                        }
                    });
                   }
   
                if(withRelease){
                    scope.submittedSession.ReleasedPhase = true;
                    scope.submittedSession.TraineeSessions.filter(x => !x.Absent).forEach(function(trainee){
                        trainee.Released = true;
                    });
                }

                if(isGround){
                    return TrainingSessionFactory.submitSession(scope.submittedSession);
                }
                else{
                    return FlightSessionFactory.submitSession(scope.submittedSession);
                }
            }

            function PrepareSessionForSubmission(Trainees) {
                // Filter Trainee Sessions
                var trainees = Trainees.filter(x => x.EligibilityStatus);
                trainees.forEach(function (trainee) {
                    trainee.Session.Items = trainee.Session.Items.filter(x => x.Selected);
                    
                    // Empty absent trainee sessions
                    if (trainee.Session.Absent) {
                        trainee.Session.Items = [];
                        trainee.Session.DayGrading.Comments = null;
                        trainee.Session.DayGrading.Competences = [];
                        trainee.Session.DayGrading.Grade = null;
                        trainee.Session.ReleaseGrading.Comments = null;
                        trainee.Session.ReleaseGrading.Competences = [];
                        trainee.Session.ReleaseGrading.Grade = null;
                        trainee.Session.NeedsAdditionalTraining = false;
                        trainee.Session.AdditionalTrainingRemarks = null;
                    }
                });

                var sessionSectors = [];
                if(!isGround){
                    //Collect session sectors for flight
                    trainingFlightIds.forEach(function(flightId){
                        var sector = {
                            FlightId : flightId,
                            PM: null,
                            PF: null,
                            SessionSectorSeats : []
                        };

                        sessionSectors.push(sector);
                    });

                }

                // Create Session
                scope.submittedSession = {
                    SessionDate: date,
                    CourseId: courseId,
                    GroundDutyIds: isGround ? [dutyId] : [],
                    Sectors: sessionSectors,
                    AircraftVisits: scope.course.Media && scope.course.Media.radioModel == "Aircraft" ? scope.course.Media.inputAircrafts : [],
                    SelectedMedia: scope.course.Media ? scope.course.Media.radioModel : "",
                    SyntheticDeviceId: scope.course.Media && scope.course.Media.radioModel == "Simulator" ? scope.course.Media.selectedDevice.selection : null,
                    ReleasedPhase: scope.course.ReleasedPhase,
                    GradeType: scope.selectedPhase.DayGrading.GradeType,
                    ReleaseGradeType: scope.selectedPhase.ReleaseGrading.GradeType,
                    TraineeSessions: trainees.map(x => x.Session),
                    SyllabusVersionId: scope.selectedPhase.Syllabus ? scope.selectedPhase.Syllabus.SyllabusVersionId : null,
                    PhaseId: scope.selectedPhase.PhaseId,
                    DowntimeDuration: scope.course.Media && scope.course.Media.radioModel == "Simulator" &&  scope.downtimeDuration.radioValue == 'true'? scope.downtimeDuration.minutes : null,
                };

            }


            function isValidForm() {
                /*Requirements before submitting a session
                    1. OnLine Mode
                    2. Date Allowed
                    3. Pending syllabus items
                    4. Pending syllabus items for different trainee
                    5. Media Validation
                    6. Day Grading
                    7. Release Grading
                    8. Certificate Exam Grading
                    9. Trainee Signature
                */

                var isValid = false;
                var info = {
                    border: "",
                    icon: "",
                    msg: "",
                    scrollToTop: false
                };

                if (!window.navigator.onLine) {
                    info = {
                        border: "border-left-red",
                        icon: "fa-warning text-red",
                        msg: "  <strong>Online mode</strong> is required in order to submit a training. <p>Check your connection and try again!</p>",
                        scrollToTop: false
                    };
                }
                else if (!dateAllowed()) {
                    info = {
                        border: "border-left-red",
                        icon: "fa-calendar-times-o text-red",
                        msg: "You can not submit a session earlier than its duty date!",
                        scrollToTop: false
                    };
                }
                else if(scope.requiresTraineeSignature && !scope.allSignaturesComplete){

                    if(scope.selectedTrainee && !scope.selectedTrainee.Session.Authorized){
                        info = {
                            border: "border-left-orange",
                            icon: "fa-pencil-square-o text-orange",
                            msg: "<b>" + scope.selectedTrainee.Name + "</b> needs to sign the form!",
                            scrollToTop:false
                        };
                    }
                    else{
                        info = {
                            border: "border-left-orange",
                            icon: "fa-warning text-orange",
                            msg: "All trainees need to sign their forms!",
                            scrollToTop:true
                        };
                    }
                }
                else if (syllabusPending()) {
                    var traineeDetailsMsg = "";
                    if(scope.selectedTrainee && (scope.selectedPhase.Syllabus.IsGradable || scope.selectedPhase.InFlight))  {
                        traineeDetailsMsg = " for <b>" + scope.selectedTrainee.Name + "</b>"
                    }
                    info = {
                        border: "border-left-orange",
                        icon: "fa-calendar-times-o text-orange",
                        msg: "Form cannot be submitted! <p>Please complete all mandatory syllabus items" + traineeDetailsMsg +"</p>",
                        scrollToTop:false
                    };
                }
                else if(traineesPending()){
                    info = {
                        border: "border-left-orange",
                        icon: "fa-calendar-times-o text-orange",
                        msg: "Form cannot be submitted! <p>Please complete all trainee forms. </p>",
                        scrollToTop:true
                    };
                }
                else if (!isMediaValid()) {
                    if (scope.hasNoAircraft) {
                        info = {
                            border: "border-left-orange",
                            icon: "fa-plane text-orange",
                            msg: "You need to provide an aircraft type!",
                            scrollToTop:true
                        };
                    }
                    else if (scope.hasNoDevice) {
                        info = {
                            border: "border-left-orange",
                            icon: "fa-plane text-orange",
                            msg: "You need to select a synthetic device!",
                            scrollToTop:true
                        };

                    }
                }
                else if(!isSyllabusGradingValid()){
                    var invalidTrainees = scope.trainees.filter(t => t.Session.SyllabusValidationErrors && t.Session.SyllabusValidationErrors.Items.length);
                    info = {
                        border: "border-left-orange",
                        icon: "fa-warning text-orange",
                        msg: "Some of the selected syllabus items require a grading",
                        SyllabusErrors : invalidTrainees.map(t => t.Session.SyllabusValidationErrors),
                        scrollToTop:false
                    };
                }
                else if (!isGradingValid()) {
                    if (!scope.gradingValidationInfo.isDayCompetencesValid || !scope.gradingValidationInfo.isReleaseCompetencesValid) {
                        info = {
                            border: "border-left-orange",
                            icon: "fa-warning text-orange",
                            msg: "You need to grade all competences before submitting!",
                            scrollToTop:false
                        };
                    }
                    else if (!scope.gradingValidationInfo.isDayGradingValid || !scope.gradingValidationInfo.isReleaseGradingValid) {
                        info = {
                            border: "border-left-orange",
                            icon: "fa-warning text-orange",
                            msg: "You need to grade all trainees!",
                            scrollToTop:false
                        };
                    }
                    else if (!scope.gradingValidationInfo.isCertificateGradingValid) {
                        info = {
                            border: "border-left-orange",
                            icon: "fa-warning text-orange",
                            msg: "You need to grade all certificate exams!",
                            scrollToTop:false
                        };
                    }
                }
                else {
                    isValid = true;
                }

                scope.info = info;
                return isValid;
            }

            
            function dateAllowed() {
                var dateAllowed = false;

                //Submission is allowed only on the day of the training and after
                var trainingDay = moment.utc(date).valueOf();
                var today = moment.utc().valueOf();

                if (today >= trainingDay) {
                    dateAllowed = true;
                }

                return dateAllowed;
            }

            function syllabusPending(){
                var syllabus = scope.selectedPhase.Syllabus;
                var type = scope.selectedPhase.ModuleType;

                return syllabus && type == 'Check' && ( (scope.selectedTrainee && !scope.selectedTrainee.AvailableRelease) || ((!scope.selectedTrainee && scope.trainees.filter(x => !x.Session.Absent).some(x => !x.AvailableRelease))) );
            }

            function traineesPending(){
                var syllabus = scope.selectedPhase.Syllabus;
                var type = scope.selectedPhase.ModuleType;

                return syllabus && type == 'Check' && scope.selectedTrainee && scope.trainees.filter(x => !x.Session.Absent).some(x => !x.AvailableRelease);
            }

            function isSyllabusGradingValid(){
                var syllabus = scope.selectedPhase.Syllabus;
                if(syllabus && syllabus.IsGradable){
                    
                    var gradableSyllabusItems = syllabus.SyllabusItems.filter(x => x.IsGradable);
                    var gradableSyllabusItemIds = gradableSyllabusItems.map(x => x.Id);

                    //foreach trainee get selected tries that need grading
                    scope.trainees.filter(x => !x.Session.Absent).forEach(function(trainee){
                        var invalidItems = [];
                        trainee.Session.Items.filter(x => x.Selected && gradableSyllabusItemIds.includes(x.Id)).forEach(function(selectedItem){
                            var syllabusItem = gradableSyllabusItems.find(x => x.Id == selectedItem.Id);
                            var gradingType = syllabusItem.GradeType; //Numeric or Outcome or Competences
                            var traineeSelectedTries = selectedItem.Tries.filter(x => x.Selected);

                            traineeSelectedTries.forEach(function(selectedTry){

                                var invalidGrading = gradingType != "Competences" && !selectedTry.TryGrading.Grade;
                                var invalidCompetences = gradingType == "Competences" && !selectedTry.TryGrading.isCompetenceValid;
                                
                                if(invalidGrading || invalidCompetences){
                                    invalidItems.push(syllabusItem.Title);
                                }
                            });
                        });
                        trainee.Session.SyllabusValidationErrors = {
                            Name : trainee.Name,
                            Items : invalidItems
                        };
                    });    
                }

                return !scope.trainees.some(t => t.Session.SyllabusValidationErrors && t.Session.SyllabusValidationErrors.Items.length);
            }

            function isGradingValid() {
                var isDayGradingValid = scope.selectedPhase.DayGrading.GradeType == "NotSet";
                var isReleaseGradingValid = scope.selectedPhase.ReleaseGrading.GradeType == "NotSet" || scope.selectedPhase.ReleaseGrading.GradeType == "CertificateExam" || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
                var isCertificateGradingValid = scope.selectedPhase.ReleaseGrading.GradeType != "CertificateExam" || !scope.course.ReleasedPhase;
                var isDayCompetencesValid = scope.selectedPhase.DayGrading.Competences.length == 0;
                var isReleaseCompetencesValid = scope.selectedPhase.ReleaseGrading.Competences.length == 0 || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;

                if (!isDayGradingValid) isDayGradingValid = !scope.trainees.filter(x => !x.Session.Absent).some(x => !x.Session.DayGrading.isGradeValid);
                if (!isReleaseGradingValid) isReleaseGradingValid = !scope.trainees.filter(x => !x.Session.Absent && x.Session.Released).some(x => !x.Session.ReleaseGrading.isGradeValid);
                if (!isCertificateGradingValid) isCertificateGradingValid = !scope.trainees.filter(x => !x.Session.Absent && x.AvailableRelease).some(x => !x.Session.ReleaseGrading.isCertificateValid);


                if (!isDayCompetencesValid) isDayCompetencesValid = !scope.trainees.filter(x => !x.Session.Absent).some(x => !x.Session.DayGrading.isCompetenceValid);
                if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !scope.trainees.filter(x => !x.Session.Absent && x.Session.Released).some(x => !x.Session.ReleaseGrading.isCompetenceValid);

                scope.gradingValidationInfo = {
                    isDayGradingValid: isDayGradingValid,
                    isReleaseGradingValid: isReleaseGradingValid,
                    isDayCompetencesValid: isDayCompetencesValid,
                    isReleaseCompetencesValid: isReleaseCompetencesValid,
                    isCertificateGradingValid: isCertificateGradingValid
                };

                return isDayGradingValid && isReleaseGradingValid && isDayCompetencesValid && isReleaseCompetencesValid && isCertificateGradingValid;
            }

            function isTraineeGradingValid(trainee) {
                var isDayGradingValid = scope.selectedPhase.DayGrading.GradeType == "NotSet";
                var isReleaseGradingValid = scope.selectedPhase.ReleaseGrading.GradeType == "NotSet" || scope.selectedPhase.ReleaseGrading.GradeType == "CertificateExam" || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
                var isCertificateGradingValid = scope.selectedPhase.ReleaseGrading.GradeType != "CertificateExam" || !scope.course.ReleasedPhase;
                var isDayCompetencesValid = scope.selectedPhase.DayGrading.Competences.length == 0;
                var isReleaseCompetencesValid = scope.selectedPhase.ReleaseGrading.Competences.length == 0 || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;

                if (!isDayGradingValid) isDayGradingValid = trainee.Session.DayGrading.isGradeValid;
                if (!isReleaseGradingValid) isReleaseGradingValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isGradeValid;
                if (!isCertificateGradingValid) isCertificateGradingValid = !trainee.AvailableRelease ||  trainee.Session.ReleaseGrading.isCertificateValid;


                if (!isDayCompetencesValid) isDayCompetencesValid = trainee.Session.DayGrading.isCompetenceValid;
                if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isCompetenceValid;

                trainee.Session.gradingValidationInfo = {
                    isDayGradingValid: isDayGradingValid,
                    isReleaseGradingValid: isReleaseGradingValid,
                    isDayCompetencesValid: isDayCompetencesValid,
                    isReleaseCompetencesValid: isReleaseCompetencesValid,
                    isCertificateGradingValid: isCertificateGradingValid
                };

                return isDayGradingValid && isReleaseGradingValid && isDayCompetencesValid && isReleaseCompetencesValid && isCertificateGradingValid;
            }

            function hasLowDayGrading(trainee){
                scope.traineeHasLowGrading = false;
                var hasDayNumericGrading = scope.selectedPhase.DayGrading.GradeType == "Numeric";
                var hasDayOutcomeGrading = scope.selectedPhase.DayGrading.GradeType == "Outcome";
                var hasDayCompetences = scope.selectedPhase.DayGrading.Competences.length > 0;

                if(trainee != null) {
                    if(hasDayNumericGrading && (trainee.Session.DayGrading.Grade == 1 || trainee.Session.DayGrading.Grade == 2)) {
                        scope.traineeHasLowGrading = true;
                    }
                    if(hasDayOutcomeGrading && (trainee.Session.DayGrading.Grade == "Fail" || trainee.Session.DayGrading.Grade == "PasswithTrainingRecommendation")) {
                        scope.traineeHasLowGrading = true;
                    }
                    if(hasDayCompetences) {
                        trainee.Session.DayGrading.Competences.forEach(function (competence) {
                         if(competence.hasMandatory)          
                          scope.traineeHasLowGrading = true;
                        })              
                    }
                }
               

              return scope.traineeHasLowGrading;
            }

            function hasLowSyllabusGrading(trainee){
                scope.traineeHasLowSyllabusGrading = false;

                var syllabus = scope.selectedPhase.Syllabus;
                if(trainee != null){
                    if(syllabus && syllabus.IsGradable){
                    
                        var gradableSyllabusItems = syllabus.SyllabusItems.filter(x => x.IsGradable);
                        var gradableSyllabusItemIds = gradableSyllabusItems.map(x => x.Id);
    
                        //get selected tries that has low grading
                            trainee.Session.Items.filter(x => x.Selected && gradableSyllabusItemIds.includes(x.Id)).forEach(function(selectedItem){
                                var traineeSelectedTries = selectedItem.Tries.filter(x => x.Selected);
    
                                traineeSelectedTries.forEach(function(selectedTry){
                                    if(selectedTry.TryGrading.Grade == 1 || selectedTry.TryGrading.Grade == 2 || selectedTry.TryGrading.Grade == 'Fail')
                                    scope.traineeHasLowSyllabusGrading = true;
    
                                    if(selectedTry.TryGrading.GradeType == 'Competences'){
                                        selectedTry.TryGrading.Competences.forEach(function (competence) {
                                            if(competence.hasMandatory)          
                                             scope.traineeHasLowSyllabusGrading = true;
                                        })
                                    }
                                });
                              
                            });
                             
                    }
                }
                
                return scope.traineeHasLowSyllabusGrading;
            }

            function isMediaValid() {
                scope.hasNoAircraft = scope.course.Media && scope.course.Media.radioModel == "Aircraft" && !scope.course.Media.inputAircrafts.length;
                scope.hasNoDevice = scope.course.Media && scope.course.Media.radioModel == "Simulator" && !scope.course.Media.selectedDevice.selection;
                return !scope.hasNoAircraft && !scope.hasNoDevice;
            }

            /**
             * Triggered after a trainee has successfully signed
             */
            function updateTraineeSignatures(){
                updateSession();
                scope.allSignaturesComplete = !scope.trainees.filter(x => !x.Session.Absent).some(x => !x.Session.Authorized);
                scope.someSignaturesComplete = scope.trainees.filter(x => !x.Session.Absent).some(x => x.Session.Authorized);
            }

            function close() {
                scope.modalInstance.close();

                if(scope.info && scope.info.scrollToTop){
                    $window.scrollTo(0, 0);
                }
            }

            function showReleasePanel(syllabus){
                var retVal = false;
                var phase = scope.selectedPhase;
                
                var availableCourse = scope.availableCourse && scope.trainees.length;
                var isCheck = phase.ModuleType=='Check';
                var releaseGrading =    (phase.ReleaseGrading.Comments || 
                                        phase.ReleaseGrading.GradeType == 'Numeric' || 
                                        phase.ReleaseGrading.GradeType == 'Outcome' ||
                                        phase.ReleaseGrading.Competences.length) &&
                                        phase.ReleaseGrading.GradeType != 'CertificateExam';

                if(isCheck){
                    retVal = availableCourse && releaseGrading;
                }
                else if(scope.traineeSyllabi.length > 1){
                    var crewId = syllabus.TraineeIds[0];
                    var trainee = scope.trainees.find(x => x.CrewId == crewId);
                    retVal = scope.reloadRelease && trainee.AvailableRelease && trainee.Session.Released && availableCourse && releaseGrading;
                }
                else{
                    retVal = scope.reloadRelease && scope.course.AvailableRelease && scope.course.ReleasedPhase && availableCourse && releaseGrading;
                }
                return retVal;
            }

            function releaseTrainee(syllabus){

                var crewIds = syllabus.TraineeIds;
                var trainees = scope.trainees.filter(x => crewIds.includes(x.CrewId));

                trainees.forEach(function(trainee){
                    trainee.Session.Released = !trainee.Session.Released;
                });

                scope.course.ReleasedPhase = scope.trainees.filter(x => !x.Absent).some(x => x.Session.Released);
            }

            function releaseGroup(){
                scope.trainees.filter(x => !x.Session.Absent).forEach(function(trainee){
                    trainee.Session.Released = !trainee.Session.Released;
                });

                scope.course.ReleasedPhase = scope.trainees.filter(x => !x.Absent).some(x => x.Session.Released);

                setReleaseStatus();
            }

            function showReleaseBtn(syllabus){
                var retVal = false;

                var availableCourse = scope.availableCourse && scope.trainees.length;
                var isCheck = scope.selectedPhase.ModuleType=='Check';
               

                if(isCheck){
                    retVal = false;
                }
                else if(scope.traineeSyllabi.length > 1){
                    var crewId = syllabus.TraineeIds[0];
                    var trainee = scope.trainees.find(x => x.CrewId == crewId);
                    retVal = scope.reloadRelease && availableCourse && trainee.AvailableRelease && trainee.AdditionalTrainingStatus == 'UnderAdditionalTraining';
                }
                else{
                    retVal = scope.reloadRelease && availableCourse && scope.course.AvailableRelease;
                }

                return retVal;
            }

            function showGroupReleaseBtn(){
                var retVal = false;

                var availableCourse = scope.availableCourse && scope.trainees.length>0;
                var isCheck = scope.selectedPhase.ModuleType=='Check';
                var releaseGrading =    (scope.selectedPhase.ReleaseGrading.Comments || 
                    scope.selectedPhase.ReleaseGrading.GradeType == 'Numeric' || 
                    scope.selectedPhase.ReleaseGrading.GradeType == 'Outcome' ||
                    scope.selectedPhase.ReleaseGrading.Competences.length) &&
                    scope.selectedPhase.ReleaseGrading.GradeType != 'CertificateExam';
               

                if(isCheck){
                    retVal = false;
                }
                else{
                    retVal = scope.reloadRelease && availableCourse && releaseGrading && !scope.trainees.filter(x => !x.Session.Absent).some(x => !x.AvailableRelease && x.AdditionalTrainingStatus != 'UnderAdditionalTraining');
                }

                return retVal;
            }

            function getTraineeClass(crewId){

                isSyllabusGradingValid();

                var textClass="";

                var trainee = scope.trainees.find(x => x.CrewId == crewId);
                var syllabus = scope.selectedPhase.Syllabus;
                var type = scope.selectedPhase.ModuleType;
    
                var allSyllabusCompleted = trainee.AvailableRelease;

                //Draft status
                var selectedItems = trainee.Session.Items.some(i => i.Tries.filter(t => !t.isReadOnly).some(t => t.Selected));

                //Validate syllabus
                var validSyllabusGrading = !trainee.Session.SyllabusValidationErrors || !trainee.Session.SyllabusValidationErrors.Items.length;
                
                //Validate Day grading
                var isDayGradingValid = scope.selectedPhase.DayGrading.GradeType == "NotSet";
                var isDayCompetencesValid = scope.selectedPhase.DayGrading.Competences.length == 0;
                if (!isDayGradingValid) isDayGradingValid = trainee.Session.DayGrading.isGradeValid;
                if (!isDayCompetencesValid) isDayCompetencesValid = trainee.Session.DayGrading.isCompetenceValid;


                //Validate Release grading
                var isReleaseGradingValid = scope.selectedPhase.ReleaseGrading.GradeType == "NotSet" || scope.selectedPhase.ReleaseGrading.GradeType == "CertificateExam" 
                                            || (scope.selectedPhase.ModuleType == "Training" && (!trainee.AvailableRelease || !trainee.Session.Released));

                var isReleaseCompetencesValid = scope.selectedPhase.ReleaseGrading.Competences.length == 0 
                                                || (scope.selectedPhase.ModuleType == "Training" && (!trainee.AvailableRelease || !trainee.Session.Released));
                if (!isReleaseGradingValid) isReleaseGradingValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isGradeValid;
                if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isCompetenceValid;



                if(selectedItems){
                    textClass = "bg-amber text-white";
                    if(validSyllabusGrading && isDayGradingValid && isDayCompetencesValid && isReleaseGradingValid && isReleaseCompetencesValid
                        && (type =='Training' || allSyllabusCompleted)){
                        textClass = "bg-green text-white";
                    }
                }
                
                return textClass;
            }

            function togglePanel(panelId) {
                $('#' + panelId).toggle();
            }


            /**
             * Toggle signature panel while trainee hasn't signed yet
             * @param {object} trainee 
             */
            function openTraineeSignature(trainee){
                //Enter signature mode : trainee form becomes read-only
                if(!trainee.Session.Authorized){
                    setReleaseStatus();
                    //Trainee can sign only if his form is valid
                    if (!validateTraineeForm(trainee)) {
                        scope.modalInstance = $uibModal.open({
                            templateUrl: 'views/Training/dlgSubmitValidation.html',
                            scope: scope,
                            backdrop: 'static',
                            keyboard: false,
                            size: 'lg'
                        });
                    }
                    else{
                        scope.modalInstance = $uibModal.open({
                            templateUrl: 'views/Training/dlgTraineeSignature.html',
                            controller: 'TraineeSignatureModalCtrl',
                            scope: scope,
                            backdrop: 'static',
                            keyboard: false,
                            size: 'md',
                            resolve: {
                                trainee: function () { return trainee; },
                                signatureSuccess: function () { return updateTraineeSignatures; }
                            }
                        });
                    }
                }

                scope.someSignaturesComplete = scope.trainees.filter(x => !x.Session.Absent).some(x => x.Session.Authorized);
            }

            function validateTraineeForm(trainee) {
                var trainee = scope.selectedTrainee;

                var isValid = false;
                var info = {
                    border: "",
                    icon: "",
                    msg: "",
                    scrollToTop: false
                };

                if (!window.navigator.onLine) {
                    info = {
                        border: "border-left-red",
                        icon: "fa-warning text-red",
                        msg: "  <strong>Online mode</strong> is required in order to sign. <p>Check your connection and try again!</p>",
                        scrollToTop: false
                    };
                }
                else if (syllabusPending()) {
                    var traineeDetailsMsg = "";
                    if(trainee && (scope.selectedPhase.Syllabus.IsGradable || scope.selectedPhase.InFlight))  {
                        traineeDetailsMsg = " for <b>" + trainee.Name + "</b>"
                    }
                    info = {
                        border: "border-left-orange",
                        icon: "fa-calendar-times-o text-orange",
                        msg: "Form cannot be submitted! <p>Please complete all mandatory syllabus items" + traineeDetailsMsg +"</p>",
                        scrollToTop:false
                    };
                }
                else if(!isSyllabusGradingValid() && trainee.Session.SyllabusValidationErrors && trainee.Session.SyllabusValidationErrors.Items.length){
                    info = {
                        border: "border-left-orange",
                        icon: "fa-warning text-orange",
                        msg: "Some of the selected syllabus items require a grading",
                        SyllabusErrors : trainee.Session.SyllabusValidationErrors,
                        scrollToTop:false
                    };
                }
                else if (!isTraineeGradingValid(trainee)) {
                    if (!trainee.Session.gradingValidationInfo.isDayCompetencesValid || !trainee.Session.gradingValidationInfo.isReleaseCompetencesValid) {
                        info = {
                            border: "border-left-orange",
                            icon: "fa-warning text-orange",
                            msg: "You need to grade all competences!",
                            scrollToTop:false
                        };
                    }
                    else if (!trainee.Session.isDayGradingValid || !trainee.Session.isReleaseGradingValid) {
                        info = {
                            border: "border-left-orange",
                            icon: "fa-warning text-orange",
                            msg: "You need to select an overall grade !",
                            scrollToTop:false
                        };
                    }
                    else if (!trainee.Session.isCertificateGradingValid) {
                        info = {
                            border: "border-left-orange",
                            icon: "fa-warning text-orange",
                            msg: "You need to grade all certificate exams!",
                            scrollToTop:false
                        };
                    }
                }
                else {
                    isValid = true;
                }

                scope.info = info;
                
                
                return isValid;
            }

            function resetSignature(trainee){
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Training/dlgResetSignature.html',
                    controller: 'TraineeSignatureModalCtrl',
                    scope: scope,
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        trainee: function () { return trainee; },
                        signatureSuccess: function () { return updateTraineeSignatures; }
                    }
                });

                modalInstance.result.then(function (confirm) {
                    if(confirm){
                        trainee.Session.Authorized = false;
                        scope.trainees.find(x => x.CrewId == trainee.CrewId).Session.Authorized = false;
                        updateTraineeSignatures();
                    }
                   
                });

                
            }
        }
        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/Training/course.html',
            scope: false,
            link: link
        }
    }
})();
